<template lang="html">
  <div class="wrapper fadeInDown">
    <div class="fadeIn first">
      <img src="@/assets/gw-standard-white.png" class="login-logo">
    </div>
    <div id="formContent">
      <h4>{{$t('login.emailSent')}}</h4>
      <span>{{$t('login.emailSentVerifyAccount')}}</span>
      <br>
     <router-link style="margin-top: 10px;" to="/login">
       {{$t('button.goBack')}}
     </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sended',
};
</script>

<style lang="scss" scoped >
  @import './login.scss';
</style>
